import React from 'react';

function OgToggleField({ label, on }) {
  return (
    <div className="og-toggle">
      <div className="tt">
        <span className="lbl">{label}</span>
        <span className={'st ' + (on ? 'on' : 'off')}>{on ? 'Enabled' : 'Disabled'}</span>
      </div>
      <div className="sp" />
      <label className="switch">
        <input type="checkbox" checked={!!on} disabled readOnly />
        <span className="track" />
        <span className="thumb" />
      </label>
    </div>
  );
}

export default OgToggleField;
